"use strict";
var _Base_rpcProperties;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = exports.rpcProperties = void 0;
const tslib_1 = require("tslib");
const chain_1 = (0, tslib_1.__importDefault)(require("./chain"));
const experimental_1 = (0, tslib_1.__importDefault)(require("./experimental"));
const net_1 = (0, tslib_1.__importDefault)(require("./net"));
const pool_1 = (0, tslib_1.__importDefault)(require("./pool"));
const stats_1 = (0, tslib_1.__importDefault)(require("./stats"));
exports.rpcProperties = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, chain_1.default), experimental_1.default), net_1.default), pool_1.default), stats_1.default);
class Base {
    constructor() {
        _Base_rpcProperties.set(this, exports.rpcProperties);
    }
    get rpcProperties() {
        return (0, tslib_1.__classPrivateFieldGet)(this, _Base_rpcProperties, "f");
    }
}
exports.Base = Base;
_Base_rpcProperties = new WeakMap();
exports.default = Base;
//# sourceMappingURL=index.js.map